import { shopScene } from '../shopkit.js';

/** 车铺：攒车、修车、买零件都在这儿，掌柜肯不肯赊账，看你的脸面。 */
export const garageDoc = shopScene({
  id: 'garage',
  name: '车铺',
  shop: 'garage',
  owner: '郭大有',
  desc: '油味、铁腥味，一个满手黑油的中年人抬头看了你一眼。',
  w: 22, h: 18,
  counters: [{ gx: 8, gy: 3, len: 5, kind: 'garage' }],
  props: [
    { type: 'boss_chair', gx: 11, gy: 5 },
    { type: 'tool_rack', gx: 3, gy: 6 },
    { type: 'assembly_bench', gx: 5, gy: 10 },
    { type: 'part_shelf', gx: 4, gy: 7 },
    { type: 'parts_cabinet', gx: 5, gy: 7 },
    { type: 'forging_stove', gx: 17, gy: 5 },
    { type: 'oil_drum_labeled', gx: 18, gy: 8 },
    { type: 'tire_pile', gx: 19, gy: 12 },
    { type: 'waste_bin', gx: 2, gy: 15 },
  ],
  portals: [
    { to: 'market', gx: 11, gy: 17, spawn: [6, 24], label: '回市集' },
  ],
});

export default garageDoc;
